import React from 'react';
import { Div } from 'globalStyle';
import styled from 'styled-components';
import { Box } from '@material-ui/core';
import { routes } from 'routes';
import { Ghost, colorType } from 'components/Buttons';
import { Text, Title } from 'components/Texts';

export const Footer = () => (
  <FooterContainer>
    <Div style={{ padding: '40px 60px 0' }}>
      <ContainerInfo>
        <Box style={{ width: '34%' }}>
          <BrandTitle>
            AKAD
            <BrandOrange>E</BrandOrange>
            MIA
          </BrandTitle>
          <Text size={13} style={{ color: '#606060', lineHeight: '1.6', maxWidth: '32ch' }}>
            Plataforma de simulación educativa para instituciones de
            educación superior.
          </Text>
        </Box>

        <Box style={{ width: '20%' }}>
          <Title size={16} mb={16} style={{ color: '#606060' }}>
            Legal
          </Title>
          <Div isFlex direction="column" align="start">
            <Ghost
              href={routes.frequentQuestions}
              onColorType={colorType.GRAY}
              color="#606060"
              style={{ 'font-size': '14px' }}
              mb={12}
            >
              Preguntas frecuentes
            </Ghost>
            <Ghost
              href={routes.resources}
              onColorType={colorType.GRAY}
              color="#606060"
              style={{ 'font-size': '14px' }}
              mb={12}
            >
              Uso de marca
            </Ghost>
            <Ghost
              href={routes.termsAndConditions}
              onColorType={colorType.GRAY}
              color="#606060"
              style={{ 'font-size': '14px' }}
              mb={12}
            >
              Términos y condiciones
            </Ghost>
            <Ghost
              href={routes.dataProcessingPolicy}
              onColorType={colorType.GRAY}
              color="#606060"
              style={{ 'font-size': '14px' }}
            >
              Política de tratamiento de datos
            </Ghost>
          </Div>
        </Box>

        <Box style={{ width: '20%' }}>
          <Title size={16} mb={16} style={{ color: '#606060' }}>
            Contáctanos
          </Title>
          <Div isFlex direction="column" align="start">
            <Ghost
              href={routes.message.contactUs}
              onColorType={colorType.GRAY}
              color="#606060"
              style={{ 'font-size': '14px' }}
              mb={12}
            >
              Centro de Ayuda
            </Ghost>
            <Text size={14} style={{ color: '#5a5a5a', marginBottom: '12px' }}>
              contacto@akademia.finance
            </Text>
            <Text size={14} style={{ color: '#5a5a5a' }}>
              Bogotá, Colombia
            </Text>
          </Div>
        </Box>
      </ContainerInfo>

      <BottomBar>
        <Text size={12} style={{ color: '#8a8a8a', width: 'auto', whiteSpace: 'nowrap' }}>
          Akademia y su logotipo son marcas de sus respectivos titulares.
        </Text>
        <Text size={12} style={{ color: '#8a8a8a', width: 'auto', whiteSpace: 'nowrap' }}>
          © 2026 Akademia. Todos los derechos reservados.
        </Text>
      </BottomBar>
    </Div>
  </FooterContainer>
);

const FooterContainer = styled.div`
  width: 100%;
  height: auto;
  z-index: 6;
  background: #ffffff;
  position: relative;
`;
const ContainerInfo = styled.div`
  border-top: 2px solid #d0d0d0;
  border-bottom: 2px solid #d0d0d0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-top: 32px;
  padding-bottom: 32px;
`;
const BottomBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 0;
`;
const BrandTitle = styled.p`
  font-size: 40px;
  font-weight: 700;
  color: #0C447C;
  margin: 0 0 12px;
`;
const BrandOrange = styled.span`
  color: #FF751F;
`;
